import React, { Fragment, useEffect, useState } from "react";
import { closeModal } from "../../store/modal/modalReducer";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, Transition } from "@headlessui/react";
import ErrorBoundary from "../../containers/ErrorBoundary";

import NotificationToast from "../Helpers/NotificationToast";
import CustomButton from "../Helpers/CustomButton";
import {
  faTimes,
  faClock,
  faLocationDot,
  faLoader,
} from "@fortawesome/pro-regular-svg-icons";
import { openModal } from "../../store/modal/modalReducer";
import { format, intervalToDuration, parseISO } from "date-fns";
import { Link } from "react-router-dom";
import { getBooking } from "../../store/booking/bookingActions";
import AppointmentFileUpload from "../Forms/AppointmentFileUpload";
import AppointmentFileDisplay from "../Forms/AppointmentFileDisplay";
import Select from "react-select";

export default function ModalViewAppointment(props) {
  const [loading, setLoading] = useState(true);
  const [appointmentMain, setAppointmentMain] = useState(null);
  const [appointmentDoc, setAppointmentDoc] = useState(null);
  const [sendList, setSendList] = useState([]);
  const [resendLoading, setResendLoading] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  const dispatch = useDispatch();
  const [open] = useState(true);
  const { current_staff } = useSelector((state) => state.auth);

  const [loadAppointment, setLoadAppointment] = useState(true);
  
  // New state for tracking features
  const [noShowStatus, setNoShowStatus] = useState('Pending');
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);
  const [commentLoading, setCommentLoading] = useState(false);
  const [cloudflareUrl, setCloudflareUrl] = useState('');
  const [assignedTo, setAssignedTo] = useState('');
  const [assignmentLoading, setAssignmentLoading] = useState(false);
  const [staffUsers, setStaffUsers] = useState([]);

  useEffect(() => {
    if (loadAppointment === true) {
      setLoadAppointment(false);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}view_appointment`,
        data: { appointment_id: props.booking_id },
      })
        .then((response) => {
          setAppointmentDoc(response.data[0]);
          setAppointmentMain(response.data[1]);
          setSendList(response.data[2]);
          setNoShowStatus(response.data[0]?.no_show_status || 'Pending');
          setAssignedTo(response.data[0]?.assigned_to || '');
          setLoading(false);
          loadComments(props.booking_id);
          loadStaffUsers();
        })
        .catch(() => {
          setAppointmentDoc(null);
          setAppointmentMain(null);
          setLoading(false);
        });
    }
  }, [loadAppointment]);

  async function resendBmApproval(appointmentId) {
    setResendLoading(true);

    await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}resend_appointment`,
      data: { appointmentId: appointmentId },
    })
      .then((response) => {
        toast(
          <NotificationToast
            title={"Sent successfully"}
            message={"Your message has been sent."}
          />
        );
      })
      .catch(() => {
        toast(
          <NotificationToast
            title="Something went wrong"
            message={"Couldn't send email"}
            type="error"
          />,
          {
            autoClose: false,
          }
        );
      });

    setResendLoading(false);
  }

  async function approveRequest(appointmentId) {
    setApproveLoading(true);

    await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}approve_appointment`,
      data: { appointment_id: appointmentId, manager_id: current_staff.id },
    })
      .then((response) => {
        toast(
          <NotificationToast
            title={"Approved"}
            message={"Your appointment has been approved."}
          />
        );
        props.getBookings(props.property_id);
        dispatch(closeModal());
      })
      .catch(() => {
        toast(
          <NotificationToast
            title="Something went wrong"
            message={"Couldn't approve appointment"}
            type="error"
          />,
          {
            autoClose: false,
          }
        );
      });

    setApproveLoading(false);
  }

  async function cancelRequest(appointmentId, propertyId) {
    setResendLoading(true);

    await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}cancel_request`,
      data: { appointment_id: appointmentId },
    })
      .then((response) => {
        toast(
          <NotificationToast
            title={"Cancelled successfully"}
            message={"Your appointment has been cancelled."}
          />
        );
      })
      .catch(() => {
        toast(
          <NotificationToast
            title="Something went wrong"
            message={"Couldn't cancel appointment"}
            type="error"
          />,
          {
            autoClose: false,
          }
        );
      });

    setResendLoading(false);
    dispatch(closeModal());
  }

  async function cancelAppointment(appointmentId, propertyId, appointmentTypeId) {
    setResendLoading(true);

    await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}cancel_appointment`,
      data: { 
        appointment_id: appointmentId,
        appointment_type_id: appointmentTypeId
      },
    })
      .then((response) => {
        toast(
          <NotificationToast
            title={"Cancelled successfully"}
            message={"Your message has been sent."}
          />
        );
      })
      .catch(() => {
        toast(
          <NotificationToast
            title="Something went wrong"
            message={"Couldn't send email"}
            type="error"
          />,
          {
            autoClose: false,
          }
        );
      });

    setResendLoading(false);
    dispatch(closeModal());
  }

  const formatAppointmentTime = (date, time) => {
    if (!date || !time) return "";
    try {
      const dateTimeStr = `${date}T${time}`;
      return format(parseISO(dateTimeStr), "HH:mm");
    } catch (err) {
      console.error("Invalid date/time:", err);
      return "";
    }
  };

  async function loadComments(appointmentId) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}appointment/${appointmentId}/comments`
      );
      if (response.data.success) {
        setComments(response.data.comments);
        setCloudflareUrl(response.data.cloudflare_r2_devurl || '');
      }
    } catch (error) {
      console.error('Error loading comments:', error);
    }
  }

  async function updateStatus(newStatus) {
    setStatusLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}appointment/update_no_show_status`,
        {
          appointment_id: props.booking_id,
          no_show_status: newStatus,
          staff_id: current_staff?.id,
        }
      );
      
      if (response.data.success) {
        setNoShowStatus(newStatus);
        toast(
          <NotificationToast
            title="Status Updated"
            message={`Appointment status changed to ${newStatus}`}
          />
        );
        loadComments(props.booking_id);
      }
    } catch (error) {
      toast(
        <NotificationToast
          title="Error"
          message="Failed to update status"
          type="error"
        />,
        { autoClose: false }
      );
    }
    setStatusLoading(false);
  }

  async function submitComment() {
    if (!comment.trim()) return;
    
    setCommentLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}appointment/add_comment`,
        {
          appointment_id: props.booking_id,
          comment_text: comment,
          staff_id: current_staff?.id,
        }
      );
      
      if (response.data.success) {
        setComment('');
        toast(
          <NotificationToast
            title="Comment Added"
            message="Your comment has been added successfully"
          />
        );
        loadComments(props.booking_id);
      }
    } catch (error) {
      console.error('Error adding comment:', error);
      toast(
        <NotificationToast
          title="Error"
          message="Failed to add comment"
          type="error"
        />
      );
    }
    setCommentLoading(false);
  }

  async function loadStaffUsers() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}appointment/staff_users`
      );
      if (response.data.success) {
        setStaffUsers(response.data.users);
      }
    } catch (error) {
      console.error('Error loading staff users:', error);
    }
  }

  async function updateAssignment(userId) {
    setAssignmentLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}appointment/update_assignment`,
        {
          appointment_id: props.booking_id,
          assigned_to: userId || null,
          staff_id: current_staff?.id,
        }
      );
      
      if (response.data.success) {
        setAssignedTo(userId);
        const assignedUser = staffUsers.find(u => u.id === userId);
        const assignedName = assignedUser ? `${assignedUser.name} ${assignedUser.surname}` : '';
        toast(
          <NotificationToast
            title="Assignment Updated"
            message={`Appointment ${assignedName ? 'assigned to ' + assignedName : 'unassigned'}`}
          />
        );
        loadComments(props.booking_id);
      }
    } catch (error) {
      console.error('Error updating assignment:', error);
      toast(
        <NotificationToast
          title="Error"
          message="Failed to update assignment"
          type="error"
        />
      );
    }
    setAssignmentLoading(false);
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-50 inset-0 overflow-y-auto"
        open={open}
        onClose={() => dispatch(closeModal())}
      >
        <ErrorBoundary>
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full sm:p-6">
                <div className="block absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0"
                    onClick={() => dispatch(closeModal())}
                  >
                    <span className="sr-only">Close</span>
                    <FontAwesomeIcon
                      className="h-6 w-6"
                      aria-hidden="true"
                      icon={faTimes}
                    />
                  </button>
                </div>
                {loading === false ? (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Left Column - Existing Appointment Details */}
                    <div>
                      <h1 className="text-xl">
                        {appointmentMain?.name || "BM Meeting"}
                      </h1>

                    <p className="font-semibold ">
                      {(() => {
                        const propName = appointmentMain?.property?.name || "";

                        let aos_name = "";
                        if (appointmentDoc?.booking_a_o_s?.unit?.name) {
                          aos_name =
                            ", Unit " +
                            appointmentDoc?.booking_a_o_s?.unit?.name;
                        }

                        if (propName.startsWith("Unison -")) {
                          return "Unison" + aos_name;
                        }
                        if (propName) {
                          return propName + aos_name;
                        }
                        return "Unknown Property" + aos_name;
                      })()}
                    </p>
                    <br />
                    <p className="font-semibold ">
                      <FontAwesomeIcon icon={faClock} />{" "}
                      {appointmentMain ? (
                        <>
                          {appointmentMain.duration === 1
                            ? "15 min"
                            : appointmentMain.duration === 2
                            ? "30 min"
                            : appointmentMain.duration === 3
                            ? "45 min"
                            : appointmentMain.duration === 4
                            ? "1 hour"
                            : appointmentMain.duration === 5
                            ? " 1 hour 15 min"
                            : appointmentMain.duration === 6
                            ? "1 hour 30 min"
                            : appointmentMain.duration === 7
                            ? "1 hour 45 min"
                            : appointmentMain.duration === 8
                            ? "2 hours"
                            : ""}
                        </>
                      ) : (
                        <>
                          {appointmentDoc?.booked_date &&
                            appointmentDoc?.booked_time &&
                            appointmentDoc?.time_to && (
                              <>
                                {
                                  intervalToDuration({
                                    start: parseISO(
                                      `${appointmentDoc.booked_date}T${appointmentDoc.booked_time}`
                                    ),
                                    end: parseISO(
                                      `${appointmentDoc.booked_date}T${appointmentDoc.time_to}`
                                    ),
                                  }).hours
                                }{" "}
                                hours{" "}
                                {
                                  intervalToDuration({
                                    start: parseISO(
                                      `${appointmentDoc.booked_date}T${appointmentDoc.booked_time}`
                                    ),
                                    end: parseISO(
                                      `${appointmentDoc.booked_date}T${appointmentDoc.time_to}`
                                    ),
                                  }).minutes
                                }{" "}
                                minutes
                              </>
                            )}
                        </>
                      )}
                    </p>
                    <p className="font-semibold ">
                      <FontAwesomeIcon icon={faLocationDot} />{" "}
                      {appointmentMain?.property?.address || ""}
                    </p>
                    <br />
                    <p>
                      Appointment at:{" "}
                      <span className="font-bold">
                        {appointmentDoc?.booked_date &&
                          format(
                            parseISO(appointmentDoc.booked_date),
                            "ccc, dd MMMM yyyy"
                          )}
                        {appointmentDoc?.booked_time && ", "}
                        {formatAppointmentTime(
                          appointmentDoc?.booked_date,
                          appointmentDoc?.booked_time
                        )}
                        {appointmentDoc?.time_to && " - "}
                        {formatAppointmentTime(
                          appointmentDoc?.booked_date,
                          appointmentDoc?.time_to
                        )}
                      </span>
                    </p>
                    <br />
                    <p>
                      Appointment Status:{" "}
                      <span className="font-bold">
                        {appointmentDoc?.status === 1
                          ? "Requested"
                          : appointmentDoc?.status === 2
                          ? "Confirmed"
                          : appointmentDoc?.status === 3
                          ? "Completed"
                          : appointmentDoc?.status === 4
                          ? "Cancelled"
                          : "Unknown"}
                      </span>
                    </p>
                    <p>
                      Attending Manager:{" "}
                      <Link
                        to={{
                          pathname: "/calendar/landing",
                          query: {
                            property:
                              appointmentMain?.property_id ||
                              appointmentDoc?.property_id,
                          },
                        }}
                        onClick={() => dispatch(closeModal())}
                      >
                        <span className="font-bold">
                          {appointmentDoc?.bm !== null &&
                            appointmentDoc?.manager &&
                            `${appointmentDoc.manager.name} ${appointmentDoc.manager.surname} - ${appointmentDoc.manager.email}`}
                        </span>
                      </Link>
                    </p>
                    <br />
                    {appointmentDoc?.name && (
                      <p>
                        Name:{" "}
                        <span className="font-bold">{appointmentDoc.name}</span>
                      </p>
                    )}
                    {appointmentDoc?.email && (
                      <p>
                        Email:{" "}
                        <span className="font-bold">
                          {appointmentDoc.email}
                        </span>
                      </p>
                    )}
                    {appointmentDoc?.cell && (
                      <p>
                        Cell:{" "}
                        <span className="font-bold">
                          +{appointmentDoc.cell}
                        </span>
                      </p>
                    )}
                    {appointmentDoc?.booking_ref && (
                      <>
                        <p>
                          Booking Reference:
                          <Link
                            to={
                              "/booking/management?tag=21&user_id=" +
                              appointmentDoc.booking_ref
                                .slice(1)
                                .split("-")[0] +
                              "&booking_id=" +
                              appointmentDoc.booking_ref.split("-")[1]
                            }
                            onClick={() => {
                              dispatch(
                                getBooking(
                                  appointmentDoc.booking_ref
                                    .slice(1)
                                    .split("-")[1]
                                )
                              );
                              dispatch(closeModal());
                            }}
                          >
                            <span className="font-bold">
                              {appointmentDoc.booking_ref}
                            </span>
                          </Link>
                        </p>
                      </>
                    )}

                    {appointmentDoc?.ticket?.external_task_id && (
                      <>
                        <br />
                        <a
                          href={`https://app.asana.com/1/${appointmentDoc.ticket.asana_workspace_id}/project/${appointmentDoc.ticket.asana_project_id}/task/${appointmentDoc.ticket.external_task_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View in Asana
                        </a>
                        <br />
                      </>
                    )}

                    {appointmentDoc?.assigned_user && (
                      <>
                        <br />
                        <p>
                          Assigned to:{" "}
                          <span className="font-bold">
                            {appointmentDoc.assigned_user.name} {appointmentDoc.assigned_user.surname}
                          </span>
                        </p>
                      </>
                    )}

                    {appointmentDoc?.ticket?.asana_project_gid && (
                      <>
                        <p>
                          Asana Project:{" "}
                          <span className="font-bold">
                            {appointmentDoc.ticket.asana_project_gid}
                          </span>
                        </p>
                      </>
                    )}

                    {appointmentDoc?.ticket?.asana_assignee_gid && (
                      <>
                        <p>
                          Asana Assignee:{" "}
                          <span className="font-bold">
                            {appointmentDoc.ticket.asana_assignee_gid}
                          </span>
                        </p>
                      </>
                    )}

                    {appointmentDoc?.ticket?.assistance_type && (
                      <>
                        <p>
                          Type of Assistance:{" "}
                          <span className="font-bold">
                            {appointmentDoc.ticket.assistance_type}
                          </span>
                        </p>
                      </>
                    )}

                    {appointmentDoc?.ticket?.maintenance_option && (
                      <>
                        <p>
                          Maintenance Option:{" "}
                          <span className="font-bold">
                            {appointmentDoc.ticket.maintenance_option}
                          </span>
                        </p>
                      </>
                    )}

                    {appointmentDoc?.ticket?.maintenance_description && (
                      <>
                        <p>
                          Maintenance Details:{" "}
                          <span className="font-bold">
                            {appointmentDoc.ticket.maintenance_description}
                          </span>
                        </p>
                      </>
                    )}

                    {appointmentDoc?.description && (
                      <>
                        <br />
                        <p>Description:</p>
                        <p>{appointmentDoc.description}</p>
                      </>
                    )}
                    <br />
                    {sendList && sendList.length > 0 && (
                      <>
                        <p>Sent to:</p>
                        {sendList.map((send) => (
                          <p>{send}</p>
                        ))}
                      </>
                    )}

                    <br />
                    <p>
                      <b>Attachments:</b>
                    </p>
                    <ul>
                      {appointmentDoc?.files?.length > 0 &&
                        appointmentDoc.files.map((file) => (
                          <>
                            <li>
                              <AppointmentFileDisplay
                                file={file}
                                key={file.id}
                                showFile={true}
                                fileId={file.id}
                                onScreen={false}
                                setLoadAppointment={setLoadAppointment}
                              />
                            </li>
                          </>
                        ))}
                    </ul>

                    <br />
                    <p>
                      <b>Add Attachments:</b>
                    </p>

                    {appointmentDoc?.id && (
                      <AppointmentFileUpload
                        appointment_id={appointmentDoc.id}
                        setLoadAppointment={setLoadAppointment}
                      />
                    )}
                    <br />
                    <div class="flex">
                      {appointmentDoc?.send_to &&
                      (appointmentDoc.send_to
                        .split(",")
                        .includes(current_staff.id.toString()) ||
                        current_staff.id == 1) &&
                      appointmentDoc.status === 1 &&
                      appointmentMain?.name &&
                      (appointmentMain.name === "Plumbing Callout" ||
                        appointmentMain.name === "Electrical Callout") ? (
                        <>
                          <div>
                            <CustomButton
                              text="Approve Request"
                              onClick={() => approveRequest(appointmentDoc.id)}
                              loading={approveLoading}
                            />
                          </div>
                        </>
                      ) : null}
                      {appointmentDoc?.status !== 4 && appointmentMain?.name &&
                      (appointmentMain.name === "Plumbing Callout" ||
                        appointmentMain.name === "Electrical Callout") ? (
                        <>
                          <div className="flex flex-row-reverse flex-grow">
                            <CustomButton
                              text="Cancel Request"
                              onClick={() =>
                                cancelRequest(
                                  appointmentDoc.id,
                                  props.property_id
                                )
                              }
                              loading={resendLoading}
                            />
                          </div>
                        </>
                      ) : null}

                      {appointmentDoc?.status !== 4 && appointmentMain?.name &&
                      appointmentMain.name !== "Plumbing Callout" &&
                      appointmentMain.name !== "Electrical Callout" ? (
                        <>
                          <div className="">
                            <CustomButton
                              text="Resend Approval Request"
                              onClick={() =>
                                resendBmApproval(appointmentDoc.id)
                              }
                              loading={resendLoading}
                            />
                          </div>
                          <div className="flex flex-row-reverse flex-grow">
                            <CustomButton
                              text="Cancel Request"
                              onClick={() =>
                                cancelAppointment(
                                  appointmentDoc.id,
                                  appointmentMain?.property?.id,
                                  appointmentMain?.id
                                )
                              }
                              loading={resendLoading}
                            />
                          </div>
                        </>
                      ) : null}
                    </div>
                    </div>

                    {/* Right Column - Tracking Features */}
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-lg font-bold mb-3">Appointment Status</h3>
                        <div className="grid grid-cols-2 gap-2">
                          {['Pending', 'In Progress', 'Complete', 'No Show BM', 'No Show Tenant', 'Awaiting Parts'].map((status) => (
                            <button
                              key={status}
                              onClick={() => updateStatus(status)}
                              disabled={statusLoading || appointmentDoc?.status === 4}
                              className={`px-3 py-2 rounded text-sm font-medium transition-colors ${
                                noShowStatus === status
                                  ? 'bg-primary text-white'
                                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                              } ${(statusLoading || appointmentDoc?.status === 4) ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                              {status}
                            </button>
                          ))}
                        </div>
                      </div>

                      {appointmentDoc?.tenant_satisfaction && (
                        <div>
                          <h3 className="text-lg font-bold mb-2">Tenant Satisfaction</h3>
                          <span className={`inline-block px-3 py-2 rounded text-sm font-semibold ${
                            appointmentDoc.tenant_satisfaction.toLowerCase().includes('satisfied') && !appointmentDoc.tenant_satisfaction.toLowerCase().includes('not')
                              ? 'bg-green-100 text-green-800'
                              : appointmentDoc.tenant_satisfaction.toLowerCase().includes('not')
                              ? 'bg-red-100 text-red-800'
                              : 'bg-yellow-100 text-yellow-800'
                          }`}>
                            {appointmentDoc.tenant_satisfaction}
                          </span>
                        </div>
                      )}

                      <div>
                        <h3 className="text-lg font-bold mb-2">Assigned To</h3>
                        <Select
                          options={staffUsers.map(user => ({
                            value: user.id,
                            label: `${user.name} ${user.surname}`,
                            data: user
                          }))}
                          value={
                            assignedTo
                              ? staffUsers.find(u => u.id === assignedTo)
                                ? {
                                    value: assignedTo,
                                    label: `${staffUsers.find(u => u.id === assignedTo).name} ${staffUsers.find(u => u.id === assignedTo).surname}`
                                  }
                                : null
                              : null
                          }
                          onChange={(option) => updateAssignment(option?.value || null)}
                          placeholder="Select staff member..."
                          isClearable
                          isDisabled={assignmentLoading}
                          className="react-select-container"
                          classNamePrefix="react-select"
                        />
                      </div>

                      <div>
                        <h3 className="text-lg font-bold mb-2">Add Comment</h3>
                        <textarea
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-primary focus:border-transparent"
                          rows="3"
                          placeholder="Add a comment about this appointment..."
                        />
                        <div className="mt-2">
                          <CustomButton
                            text="Submit Comment"
                            onClick={submitComment}
                            loading={commentLoading}
                            disabled={!comment.trim() || commentLoading}
                          />
                        </div>
                      </div>

                      <div>
                        <h3 className="text-lg font-bold mb-2">Comment History</h3>
                        <div className="max-h-64 overflow-y-auto space-y-2 border border-gray-200 rounded-lg p-3">
                          {comments.length > 0 ? (
                            comments.map((commentItem) => (
                              <div key={commentItem.id} className="border-b border-gray-100 pb-2 last:border-0 flex gap-2">
                                <div className="flex-1">
                                  <p className="text-xs text-gray-500">
                                    {commentItem.User?.name} {commentItem.User?.surname} - {' '}
                                    {commentItem.created_at && format(new Date(commentItem.created_at), 'dd MMM yyyy HH:mm')}
                                  </p>
                                  <p className="text-sm mt-1">{commentItem.message}</p>
                                </div>
                                {commentItem.file_details && commentItem.file_details.length > 0 && (
                                  <div className="flex flex-col gap-1">
                                    {commentItem.file_details.map((file) => {
                                      // Build Cloudflare R2 URL: CLOUDFLARE_R2_DEVURL/uploads/{path}{name}.{extension}
                                      const imageUrl = cloudflareUrl 
                                        ? `${cloudflareUrl}/uploads/${file.path}${file.name}.${file.extension}`
                                        : `${process.env.REACT_APP_API_URL}public/file/preview/${file.id}`;
                                      
                                      return (
                                        <img
                                          key={file.id}
                                          src={imageUrl}
                                          alt="Attachment"
                                          className="w-12 h-12 object-cover rounded cursor-pointer hover:opacity-80 transition-opacity border border-gray-300"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch(
                                              openModal({
                                                modal_type: "ModalViewFiles",
                                                modal_props: {
                                                  booking_id: appointmentDoc?.booking_ref?.split('-')[1],
                                                  files: [{ id: file.id }],
                                                },
                                              })
                                            );
                                          }}
                                          title="Click to view full size"
                                        />
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            ))
                          ) : (
                            <p className="text-sm text-gray-500 text-center py-4">No comments yet</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <FontAwesomeIcon
                    className="h-10 w-10 text-gray-900 animate-spin ml-52"
                    icon={faLoader}
                  />
                )}
              </div>
            </Transition.Child>
          </div>
        </ErrorBoundary>
      </Dialog>
    </Transition.Root>
  );
}
